module.exports = __webpack_public_path__ + "assets/img/marriage-title-bg1.2b36ce13.png";